import { useContext } from "react";

import { LanguageContext } from "../contexts/language";

export function useLanguage() {
  const context = useContext(LanguageContext);

  if (!context) {
    throw new Error("useLanguage hook must be used inside a language provider");
  }

  return context;
}
